import { AvailableLocale } from '@omnea-digital/toolbox'
import { CurrencyCode } from 'utils/currency/getCurrencyCodes'
import { getISOCode } from './getISOCode'

export const formatMonetaryAmount = (
  amount: number,
  currency: CurrencyCode,
  locale: AvailableLocale,
  options: Omit<Intl.NumberFormatOptions, 'style' | 'currency'> = { maximumFractionDigits: 2, minimumFractionDigits: 2 }
) => {
  // TODO: make this better
  if (!currency) {
    return ''
  }

  const { code } = getISOCode(currency)

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: code,
    ...options,
  }).format(amount)
}
